import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { SpirApplicationsState } from '@/store/applications/spir/types'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const SpirApplications: Module<SpirApplicationsState, RootState> = {
  state: () => ({
    applications: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
  }),
  mutations,
  actions,
  getters,
}

export default SpirApplications
